import { TextLink } from '@ovotech/nebula';
import React from 'react';
import { FootnoteReferencedContent } from '@/src/components';
import { BEYOND_TERMS } from '@/src/constants/links';

const homeRecoverDisclaimer = (
  <>
    Terms, conditions, eligibility criteria, and exclusions and cancellation
    charges apply.
  </>
);

export const footnoteHomeRecoverPromo: FootnoteReferencedContent = {
  id: 'HomeRecoverPromo',
  body: [homeRecoverDisclaimer],
};

const beyondTerms = (
  <TextLink href={BEYOND_TERMS} opensInNewWindow>
    Beyond terms
  </TextLink>
);

export const bottomBeyondBannerTerms: FootnoteReferencedContent = {
  id: 'beyondTerms',
  body: [beyondTerms],
};

export const getOfferFootnote = (
  endDate: string | undefined,
): FootnoteReferencedContent => {
  return {
    id: 'percentDiscountPromotionFootnote',
    body: [
      <>
        Offer not available on all products or for CORGI HomePlan and OVO Boiler
        Cover customers who have had a plan in the last 30 days. To be eligible
        for this offer you must meet the boiler cover eligibility criteria set
        out during sign up. Cancellation fees apply. Offer expires{' '}
        {endDate && endDate}
      </>,
    ],
  };
};
